import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { invoiceIntegrationsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../../auth'
// Invoices Integrations App
const XeroApp = () => import('@/pmd/pages/payments/payment-products/invoices-integrations/Xero.vue')
const WaveApp = () => import('@/pmd/pages/payments/payment-products/invoices-integrations/Wave.vue')
const QuickbooksApp = () => import('@/pmd/pages/payments/payment-products/invoices-integrations/Quickbooks.vue')

export const invoicesIntegrationsRoutes: RouteConfig[] = [
  {
    path: 'payments/v2/invoices-integrations/xero',
    name: invoiceIntegrationsRouteNames.invoicesIntegrationsXero,
    component: XeroApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
  {
    path: 'payments/v2/invoices-integrations/wave',
    name: invoiceIntegrationsRouteNames.invoicesIntegrationsWave,
    component: WaveApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
  {
    path: 'payments/v2/invoices-integrations/quickbooks',
    name: invoiceIntegrationsRouteNames.invoicesIntegrationsQuickbooks,
    component:  QuickbooksApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
        hideSideBar: true,
        hideTopBar: true,
        translations: [Modules.Payments],
    },
    children: []
  }
]
